interface LoadErrorProps {
    title: string;
    message?: string;
    onRetry: () => void;
    /// h1 when it's the only heading on the page, otherwise h2
    headingLevel?: 1 | 2;
}

/// Card shown when data fails to load, with a way to try again
export function LoadError({
    title,
    message = "The forecast service didn’t respond. Please try again in a moment.",
    onRetry,
    headingLevel = 2,
}: LoadErrorProps) {
    const Heading = headingLevel === 1 ? "h1" : "h2";
    return (
        <section className="cw-card load-error" role="alert">
            <Heading className="cw-card__title">{title}</Heading>
            <p className="cw-card__message">{message}</p>
            <button type="button" className="cw-button" onClick={onRetry}>Try again</button>
        </section>
    );
}
